import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { trainerMessagesApi } from '../api/trainerMessages';
import { queryKeys } from '../queryKeys';

export function useTrainerMessageThread(batchId: string, trainerId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.trainerMessages.thread(batchId, trainerId),
    queryFn: () => trainerMessagesApi.thread(batchId, trainerId || undefined),
    enabled,
    refetchInterval: 15_000,
  });
}

export function useSendTrainerMessage(invalidateKey: unknown[]) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: trainerMessagesApi.send,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invalidateKey });
    },
  });
}
